import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
import { SkipToMainComponent } from './skip-to-main.component';

@NgModule({
  imports: [CommonModule, MatButtonModule, TranslatePipe],
  declarations: [SkipToMainComponent],
  exports: [SkipToMainComponent]
})
export class SkipToMainModule {}
